import type { CareNavigationDefinitionResponse } from "./careNavigationCriteria";
import { CarespaceCountLink } from "./carespaceCountLink";
import { KpiCard, KpiGrid } from "./dashboardKit";

const statuses = [
  { key: "inWindow", field: "reassessmentInWindowCount", label: "In window" },
  { key: "upcoming", field: "reassessmentUpcomingCount", label: "Upcoming" },
  {
    key: "overdue",
    field: "reassessmentOverdueCount",
    label: "Overdue",
    description: "Past submission deadline; nothing submitted.",
  },
  {
    key: "pending",
    field: "reassessmentPendingCount",
    label: "Pending",
    description: "Submitted, awaiting Medicare approval.",
  },
] as const;

export function CareNavigationReassessmentStatus(props: {
  rows: CareNavigationDefinitionResponse["rows"];
  available: boolean;
}) {
  return (
    <KpiGrid>
      {statuses.map((status) => (
        <KpiCard
          key={status.key}
          label={status.label}
          value={
            <CarespaceCountLink
              count={
                props.available ? props.rows.reduce((sum, row) => sum + row[status.field], 0) : null
              }
              recordIds={
                props.available
                  ? [...new Set(props.rows.flatMap((row) => row.recordIds?.[status.key] ?? []))]
                  : undefined
              }
              label={`${status.label} reassessments`}
            />
          }
          footnote={"description" in status ? status.description : undefined}
        />
      ))}
    </KpiGrid>
  );
}
